export default "__VITE_ASSET__CeE$9SO6__"